import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import UserService from "../services/UserService";
import "../styles/profile.css";
import { Servers } from "../services/http/server";
import { useNavigate } from "react-router-dom";
import LoginModal from "../components/LoginModal";
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store/store';
import { logout } from '../store/authSlice';

interface ProfileMenuProps {
  isLoggedIn: boolean;
  userName: string | "";
}
export interface ILoginCredentials {
  userName: string; // This can be an email or phone number
  otp?: string;      // OTP for authentication
}
const ProfileMenu: React.FC<ProfileMenuProps> = ({ isLoggedIn, userName }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isModalActive, setModalActive] = useState(false);
  const [phoneOrEmail, setPhoneOrEmail] = useState(""); // This will be either phone or email
  const [otp, setOtp] = useState(""); // OTP field
  const [otpSent, setOtpSent] = useState(false); // Flag to track OTP sent status
  const tenantId = Servers.TENANTID;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileMenuRef = useRef<HTMLDivElement>(null);

  const prepareLoginBody = (userName: string, otp: string, tenantId: string): ILoginCredentials => {
    return {
      userName,
      otp
    };
  };

    // Toggle profile menu on click
    const toggleDropdown = () => {
      isLoggedIn?navigate("/accounts"):toggleModal();
      //setDropdownOpen((prev) => !prev);
    };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  // Effect to add/remove class on the body when the modal is active
  useEffect(() => {
    if (isModalActive) {
      document.body.classList.add("modal-active");
    } else {
      document.body.classList.remove("modal-active");
    }
  }, [isModalActive]);

  const toggleModal = () => {
    setModalActive(!isModalActive);
  };

  const handleLoginSuccess = (token: string, userName: string, loginid: string) => {
    localStorage.setItem("token", token);
    localStorage.setItem("username", userName);
    localStorage.setItem("loginid", loginid);
    navigate(0);
  };
  const handleLogout = () => {
    dispatch(logout()); // Dispatch logout action when user clicks logout
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate(0);
  };

  return (
    <div
      className="profile-menu-container"  ref={profileMenuRef}
      // onMouseEnter={() => setDropdownOpen(true)}
      // onMouseLeave={() => setDropdownOpen(false)}
    >

      {/* Profile Icon and User Greeting */}
      <div className="profile-icon" onClick={toggleDropdown}>
        <span className="material-icons">account_circle</span>
        {/* {isLoggedIn && <span className="user-greeting is-hidden-mobile">Hi, {userName || "User"}</span>} */}
      </div>

      {/* Dropdown Menu */}
      {isDropdownOpen && (
        <div className="profile-dropdown">
          {isLoggedIn ? (
            <ul className="dropdown-list">
              <li>
                <Link to="/accounts/wishlist" className="dropdown-link">
                  <span className="material-icons">favorite</span> Wishlist
                </Link>
              </li>
              <li>
                <Link to="/accounts/orders" className="dropdown-link">
                  <span className="material-icons">shopping_bag</span> Orders
                </Link>
              </li>
              <li>
                <Link to="/accounts/profile" className="dropdown-link">
                  <span className="material-icons">settings</span> Accounts
                </Link>
              </li>
              <li>
                <button
                  className="logout-btn"
                  onClick={handleLogout}
                >
                  <span className="material-icons">logout</span> Logout
                </button>
              </li>
            </ul>
          ) : (
            <ul className="dropdown-list">
              <li>
                <button className="dropdown-link login-btn" onClick={toggleModal}>
                  <span className="material-icons">login</span> Login
                </button>
              </li>              
            </ul>
          )}
        </div>
      )}


      {/* Modal */}
      {isModalActive && (
        <>
          {/* Background Blur */}
          {/* <div className="blur-background"></div> */}

          {/* Login Modal */}
          <LoginModal
            isActive={isModalActive}
            toggleModal={toggleModal}
            onSuccess={handleLoginSuccess}
          />
        </>
      )}
    </div>
  );
};

export default ProfileMenu;
